import { ArtistAttachment as GQLItem } from '../../generated/graphql';
import * as Attachment from '../Attachment/Attachment';
import { z } from 'zod';

export const artistAttachmentSchema = z.object({
  attachment: Attachment.attachmentSchema,
});

export type ArtistAttachment = z.infer<typeof artistAttachmentSchema>;

// Write shape sent to `saveArtist` (ArtistAttachmentInput). Attachments are
// upsert-only server-side: one omitted from the list is left untouched, so
// removing an image means sending it back with `_destroy: true`.
export type ArtistAttachmentInput = {
  attachmentId: number;
  _destroy?: boolean;
};

export const fromGql = (item: GQLItem): ArtistAttachment => ({
  attachment: Attachment.fromGql(item.attachment),
});

export const fromGqlCollection = (items: GQLItem[]): ArtistAttachment[] =>
  items.map(fromGql);
